<template>
  <b-card>
    <b-modal v-model="showConfirm" title="Confirm Changes" centered hide-footer>
      <p class="text-black">
        New bonus bets will be placed in <b>{{ symbol }}</b>. Existing bonus
        bets are not changed. Continue?
      </p>
      <div class="d-flex justify-content-end">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="showConfirm = false"
          >Cancel</b-button
        >
        <b-button variant="success" :disabled="saving" @click="handleSave">
          <b-spinner v-if="saving" small class="mr-50" />
          Confirm &amp; Save
        </b-button>
      </div>
    </b-modal>

    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>
    <b-form v-else @submit.prevent>
      <p class="font-weight-bolder border-bottom">Bonus Bet Token</p>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label class="font-weight-bold" for="bonus-bet-token"
              >Token used for bonus bets</label
            >
            <b-form-select
              id="bonus-bet-token"
              v-model="symbol"
              :options="tokenOptions"
            />
            <small class="text-muted"
              >Only applies to newly placed bonus bets.</small
            >
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <div class="d-flex justify-content-end align-items-center">
            <b-button
              variant="success"
              :disabled="saving || !symbol || symbol === savedSymbol"
              @click="showConfirm = true"
            >
              <feather-icon icon="SaveIcon" />
              Save Changes</b-button
            >
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BButton,
  BModal,
  BSpinner,
} from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";

const TOKENS = ["USDC", "USDT"];

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BButton,
    BModal,
    BSpinner,
  },
  data() {
    return {
      showConfirm: false,
      symbol: null,
      savedSymbol: null,
    };
  },
  computed: {
    ...mapState("settings/bonus-bet-token-symbol", ["loading", "saving"]),
    tokenOptions() {
      // keep an unknown saved value selectable so it is not silently dropped
      const list =
        this.savedSymbol && !TOKENS.includes(this.savedSymbol)
          ? [...TOKENS, this.savedSymbol]
          : TOKENS;
      return [{ value: null, text: "Select token", disabled: true }, ...list];
    },
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    ...mapActions("settings/bonus-bet-token-symbol", [
      "getBonusBetTokenSymbol",
      "updateBonusBetTokenSymbol",
    ]),
    async fetchSettings() {
      const data = await this.getBonusBetTokenSymbol();
      if (typeof data?.value === "string") {
        this.symbol = data.value;
        this.savedSymbol = data.value;
      }
    },
    async handleSave() {
      const result = await this.updateBonusBetTokenSymbol(this.symbol);
      if (result) {
        this.savedSymbol = this.symbol;
        this.showConfirm = false;
        this.showToastSuccess(
          "Settings saved",
          "Bonus bet token updated successfully."
        );
      }
    },
  },
  setup() {
    const { showToastSuccess } = useToastHandler();
    return { showToastSuccess };
  },
};
</script>
